import React from 'react'
import styled, { createGlobalStyle } from 'styled-components'

import Footer from 'components/Layout/Footer/Footer'

import { spacing } from '@material-ui/system'
import { CssBaseline, Paper as MuiPaper, withWidth } from '@material-ui/core'

import { isWidthUp } from '@material-ui/core/withWidth'

const GlobalStyle = createGlobalStyle`
  html,
  body,
  #root {
    height: 100%;
  }

  body {
    background: ${(props) => props.theme.body.background};
  }
`

const AppContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`

const Root = styled.div`
  max-width: 520px;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 100%;
`
const RootFullWidth = styled.div`
  display: flex;
  min-height: 100vh;
`

const Paper = styled(MuiPaper)(spacing)
const MainContent = styled(Paper)`
  flex: 1;
  background: ${(props) => props.theme.body.background};

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: none;
  }

  .MuiPaper-root .MuiPaper-root {
    box-shadow: none;
  }
`

const Bare = ({ children, width, isFullWidth }) => {
  return isFullWidth ? (
    <RootFullWidth>
      <CssBaseline />
      <GlobalStyle />
      <AppContent>
        <MainContent p={isWidthUp('lg', width) ? 10 : 5}>{children}</MainContent>
        <Footer />
      </AppContent>
    </RootFullWidth>
  ) : (
    <Root>
      <CssBaseline />
      <GlobalStyle />
      {children}
    </Root>
  )
}

export default withWidth()(Bare)
